var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.todos),function(todo){return _c('Todo',{key:todo.id,attrs:{"todo":todo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }